<template>
  <div class="police-book-list page page-with-table p-2">
    <page-header class="mb-2" :title="$t('Police Books')">
      <template v-slot:buttons>
        <add-new-button @click="onGenerateReportClick">
          <font-awesome-icon icon="plus-circle" class="icon"/>
          {{ $t('Generate Report') }}
        </add-new-button>
      </template>
    </page-header>

    <div class="card content-wrapper p-2">
      <police-book-table/>
    </div>
  </div>
</template>

<script>

import PageHeader from "@/core/components/page-header/PageHeader.vue";
import {createNamespacedHelpers} from 'vuex'
import PoliceBookTable from "@/modules/police-books/PoliceBookTable.vue";
import AddNewButton from "@/core/components/common/AddNewButton.vue";
import {SOURCE_POLICE_BOOK_MODAL} from "@/modules/constants";

const {mapActions} = createNamespacedHelpers('policeBooks')

export default {
  name: "PoliceBook",
  components: {AddNewButton, PageHeader, PoliceBookTable},
  computed: {},
  methods: {
    ...mapActions(['getReports', 'showModal']),

    onGenerateReportClick() {
      this.showModal({
        object: null,
        source: SOURCE_POLICE_BOOK_MODAL
      });
    },
  },
  beforeMount() {
    this.getReports()
  }
}
</script>

<style lang="scss" scoped>
  @import "./scss/variables";

  .police-book-list {
    @include list-view-wrapper;
  }
</style>
